import { bridgeDataReady } from '@databases/database-state/state/bridge-data';

import { transformToken } from '@canvas/frame-api/canvas-frame-api';
import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';
import { type FrameToken } from '@canvas/frame-api-types';
import { setPaywallCacheFeatureData, updatePaywallFeatureState } from '@canvas/paywall';

const syncPaywallFeatureState = (token: FrameToken | undefined): boolean => {
  if (token?.features) {
    setPaywallCacheFeatureData(token.features);
    updatePaywallFeatureState(token.features);
    return true;
  }

  return false;
};

const syncPaywallFeatureStateFromBridgeData = async () => {
  const bridgeData = await bridgeDataReady.get();

  syncPaywallFeatureState(transformToken(bridgeData.token));
};

export const initializeDatabasePaywallFeatures = () => {
  void syncPaywallFeatureStateFromBridgeData();

  waitForContentAPI().then(async (contentAPI) => {
    contentAPI.onTokenInit(syncPaywallFeatureState);
    contentAPI.onTokenChange(syncPaywallFeatureState);

    try {
      const didSyncFromContentAPI = syncPaywallFeatureState(await contentAPI.getToken());

      if (!didSyncFromContentAPI) {
        await syncPaywallFeatureStateFromBridgeData();
      }
    } catch {
      await syncPaywallFeatureStateFromBridgeData();
    }
  });
};
